import { GridColDef, GridColumnGroupingModel } from "@mui/x-data-grid";
import ActionsCell from "../components/dashboard/actionButton";
import { GridRenderCellParams } from "@mui/x-data-grid";
import React from "react";
import FocusedCaseIcon from '@mui/icons-material/Star';
import NormalCaseIcon from '@mui/icons-material/StarBorder';
import { formatNumberToIndianNotation } from "../utils/commonUtils";

export const manageAllocationColumnGroup: GridColumnGroupingModel = [
    { groupId: 'Case Data', children: [
        { field: 'client_reference_id' },
        { field: 'focused' },
        { field: 'pool_month' },
        { field: 'case_id' },
        { field: 'client_name' },
        { field: 'agency_name' },
        { field: 'client_manager_username' },
        { field: 'loan_type' },
        { field: 'dpd_bucket' },
        { field: 'customer_name' },
        { field: 'customer_phone_number' },
        { field: 'assigned_agents' },
        { field: 'total_due_amount' },
        { field: 'principal_outstanding_amount' },
        { field: 'collected_amount' },
        { field: 'min_due_amount' },
        { field: 'eligible_settlement_amount' },
        { field: 'status' },
    ] },
    { groupId: 'Agent Allocation', children: [
        { field: 'agent_case_allocation_id' },
        { field: 'username' },
        { field: 'expiry_date' },
        { field: 'case_score' },
        { field: 'is_active' },
    ] },
    { groupId: 'Pincode Data', children: [
        { field: 'pin_code' },
        { field: 'area' },
        { field: 'state' },
        { field: 'district' },
    ] },
    { groupId: 'Timestamps', children: [
        { field: 'created_date' },
        { field: 'updated_date' },
        { field: 'updated_by' }
    ] }
];

export const manageAllocationColDef: GridColDef[] = [
    {
        field: 'focused',
        headerName: 'Focused Case',
        width: 50,
        filterable: false,
        sortable: false,
        hideable: false,
        renderCell: (params: GridRenderCellParams<any, any, any>) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                }}
            >
                {params.value ? (
                    <FocusedCaseIcon sx={{ color: 'orange', fontSize: 20 }} />
                ) : (
                    <NormalCaseIcon sx={{ fontSize: 20, opacity: 0.7 }} />
                )}
            </div>
        ),
    },
    {
        field: 'client_reference_id',
        headerName: 'Client Reference ID',
        renderCell: (params: GridRenderCellParams<any, any, any>) => <ActionsCell currentCaseRow={params.row} />,
        width: 150,
        filterable: true,
        sortable: true,
        hideable: false,
    },
    { field: 'pool_month', headerName: 'Pool Month', width: 150, filterable: false, sortable: false, hideable: false },
    { field: 'case_id', headerName: 'ID', width: 90, filterable: false, sortable: false, hideable: false },
    { field: 'client_name', headerName: 'Client Name', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'agency_name', headerName: 'Agency Name', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'client_manager_username', headerName: 'Client Manager Name', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'loan_type', headerName: 'Loan Type', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'dpd_bucket', headerName: 'DPD Bucket', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'customer_name', headerName: 'Customer Name', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'customer_phone_number', headerName: 'Customer Contact', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'total_due_amount', headerName: 'Total Overdue Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'principal_outstanding_amount', headerName: 'Principal Outstanding Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'collected_amount', headerName: 'Collected Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'min_due_amount', headerName: 'Minimum Due Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'eligible_settlement_amount', headerName: 'Eligible Settlement Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'status', headerName: 'Status', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'agent_case_allocation_id', headerName: 'Agent Allocation ID', width: 150, filterable: true, sortable: true, hideable: true },
    { field: 'username', headerName: 'Username', width: 150, filterable: true, sortable: true, hideable: true },
    { field: 'expiry_date', headerName: 'Expiry Date', width: 150, filterable: true, sortable: true, hideable: true },
    { field: 'case_score', headerName: 'Case Score', width: 150, filterable: true, sortable: true, hideable: true },
    { field: 'is_active', headerName: 'Allocation Status', width: 150, filterable: true, sortable: true, hideable: true },
    { field: 'pin_code', headerName: 'Pin Code', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'area', headerName: 'Area', width: 150, filterable: false, sortable: false, hideable: false },
    { field: 'state', headerName: 'State', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'district', headerName: 'District', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'created_date', headerName: 'Created Date', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'updated_date', headerName: 'Last Update Date', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'updated_by', headerName: 'Last Update By', width: 150, filterable: true, sortable: true, hideable: false },
];
